import { render, staticRenderFns } from "./ParticipacaoCustoTotalPercentual.vue?vue&type=template&id=9193ed74&scoped=true&"
import script from "./ParticipacaoCustoTotalPercentual.vue?vue&type=script&lang=js&"
export * from "./ParticipacaoCustoTotalPercentual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9193ed74",
  null
  
)

export default component.exports